/**
 * The persisted cache key used by the combined search config cache.
 *
 * This is the single source of truth for the cache name. It is used by:
 * - search-client's promiseCache (scope control for the adapter system)
 * - Host apps (e.g., Confluence StorageManager) to register the key for SSR persistence
 */
export const SEARCH_COMBINED_CONFIG_CACHE_KEY = 'search-combined-config';
